<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-lg-7">
        <h1>
          Urgent Care Wait Times
        </h1>

        <div
          v-for="announcement in announcements"
          :key="announcement.message"
          class="alert alert-info"
          role="alert"
          v-html="announcement.message"
        />

        <WaitTimes />

        <p>
          Caldwell UNC Health now offers an online reservation system allowing
          you to wait where you feel most comfortable. Choose a convenient time
          online and we’ll reserve your spot at any of our urgent care locations.
        </p>

        <p>
          Wait times are estimates of the amount of time you may wait between registering at the front desk and being
          seen by a nurse to start your care.
        </p>

        <p>
          *Please note: Patients are seen based on severity of condition, not based on arrival or reservation time.
        </p>

        <p>
          Not sure whether to go to Urgent Care or the Emergency Department?
          <router-link to="/urgent-care">
            Learn where
          </router-link>
          to seek treatment depending on your condition.
        </p>
      </div>
      <div class="d-lg-none d-xl-block col-xl-1">
        <p>&nbsp;</p>
      </div>
      <div class="col-sm-12 col-lg-5 col-xl-4">
        <div class="cta-box">
          <b>Call 911</b>
          In the event of an emergency, call 911 immediately.
        </div>
        <div class="cta-box-tail">
          <b>Important:</b>
          We only see children 6 months and older in all the urgent cares,
          except for Falls Pediatrics Plus in Granite Falls.
          At Falls Pediatrics Plus, we see newborn to 18 years.
        </div>

        <LocationContacts />
      </div>
    </div>
    <div>
      <div class="ngcom">
        <div class="ngcom__text">
          web development by
          <a href="https://nickgreene.com" rel="noopener">nickgreene.com</a>
        </div>
        <div class="ngcom__logo">
          <img src="https://ngcom-static.s3.amazonaws.com/logo-square-noborder-26x26.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WaitTimes from './WaitTimes';
import LocationContacts from './LocationContacts';

export default {
  name: 'HomeComponent',
  components: {
    WaitTimes,
    LocationContacts,
  },
  computed: {
    announcements() {
      return this.$store.state.announcements;
    },
  },
};
</script>

<style lang="scss">
h2 {
  margin-top: 3rem;
}

.ngcom {
  color: #666;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  margin: 4rem 0 2rem;
  text-align: center;

  &__text {
    flex-basis: 100%;
    order: 2;
  }

  &__logo {
    flex-shrink: 0;
    margin-bottom: 6px;
    order: 1;
  }

  a {
    background: transparent;
    border: none;
    text-decoration: none;
  }

  img {
    border: 1px solid #fff;
  }
}
</style>
